// services/frontend/src/components/signup/SignupPageLayout.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import SignupProgressSteps from './SignupProgressSteps';

/**
 * [Why]
 * 회원가입 3-step 페이지에서 공통으로 사용되는 레이아웃(헤더/진행단계/콘텐츠/하단 고정영역)을
 * 한 곳에서 관리하여 RN 앱과 동일한 UI/UX로 빠르게 맞추기 위한 컴포넌트입니다.
 *
 * [How]
 * - 페이지 헤더는 내부에서 렌더링(뒤로/타이틀 중앙 정렬)
 * - 진행 단계는 SignupProgressSteps로 렌더링
 * - 하단 고정 영역은 children과 별도로 bottomFixed로 주입
 */
export default function SignupPageLayout({
  step = 1,
  totalSteps = 3,
  title = '회원가입',
  onBack,
  children,
  bottomFixed,
}) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (typeof onBack === 'function') {
      onBack();
      return;
    }
    navigate(-1);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#fff', padding: 16 }}>
      {/* [회원가입 레이아웃] */}
      {/* - 회원가입 페이지도 다른 화면과 동일하게 최대 가로폭을 800px로 제한하고 가운데 정렬합니다. */}
      <div style={{ maxWidth: 800, margin: '0 auto' }}>
        {/* 상단 헤더(페이지 내부) */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
          <button
            type="button"
            onClick={handleBack}
            style={{
              height: 32,
              padding: '0 10px',
              borderRadius: 8,
              border: '1px solid #e5e7eb',
              background: '#fff',
              cursor: 'pointer',
              fontSize: 12,
              lineHeight: 1,
              whiteSpace: 'nowrap',
            }}
          >
            뒤로
          </button>
          <div style={{ flex: 1, textAlign: 'center', fontWeight: 600 }}>{title}</div>
          <div style={{ width: 56 }} />
        </div>

        <SignupProgressSteps currentStep={step} totalSteps={totalSteps} />

        {/* 콘텐츠 영역: 하단 고정 버튼과 겹치지 않도록 패딩 확보 */}
        <div style={{ paddingBottom: 96 }}>
          {children}
        </div>

        {bottomFixed || null}
      </div>
    </div>
  );
}
